/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Sagas of logging
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.1
 */

import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { makeSelectUsername } from '../../pages/PageAuth/selectors/authSelectors';
import { requestSaga } from '../../sagas/requestSaga';
import { API_HOSTNAME, BUSINESS_LOGGING } from '../app/Api';
import { logBusinessEventFailed, logBusinessEventSuccess } from './loggingActions';
import { ELogBusinessEventType, LOG_BUSINESS_EVENT } from './loggingConstants';
import { ILogBusinessEvent } from './loggingTypes';

export function* logBusinessEventSaga(action: ILogBusinessEvent): SagaIterator {
    try {
        const payload = action.payload;
        if (payload.type === ELogBusinessEventType.login && !payload.login) {
            payload.login = yield select(makeSelectUsername());
        }
        const queryParams = [
            `event=${payload.eventName}`,
        ];
        if (payload.login) {
            queryParams.push(
                `login=${payload.login}`,
            );
        }
        if (payload.orderId) {
            queryParams.push(
                `orderId=${payload.orderId}`,
            );
        }
        const queryString = queryParams.join('&');

        yield call(requestSaga, API_HOSTNAME + BUSINESS_LOGGING + `/${payload.type}?${queryString}`, 'POST');
        yield put(logBusinessEventSuccess());
    } catch (e) {
        yield put(logBusinessEventFailed());
    }
}

export function* loggingSaga() {
    yield takeEvery(LOG_BUSINESS_EVENT, logBusinessEventSaga);
}
